import config from '../config';
import CookieHelper from './CookieHelper';

class TokenHelper {
    setToken(tokenKey, tokenValue, expireDate) {
        const tokenJSON = {
            token: tokenValue,
            expireTime: expireDate
        };

        localStorage.setItem(tokenKey, JSON.stringify(tokenJSON));
        // 兼容cf cookie
        CookieHelper.setCookieValue(
            tokenKey,
            tokenValue,
            expireDate,
            cf.appPath
        );
    }

    getToken(tokenKey) {
        const strToken = localStorage.getItem(tokenKey);
        if (!strToken) return null;
        const tokenJSON = JSON.parse(strToken);
        if (tokenJSON.expireTime <= Date.now()) return null;

        return tokenJSON.token;
    }

    removeToken(tokenKey) {
        localStorage.removeItem(tokenKey);
        cf.utils.setCookieValue(tokenKey, null);
        CookieHelper.deleteCookie(tokenKey, cf.appPath);
    }

    setAccessToken(accessToken, expireDate) {
        const tokenJSON = {
            token: accessToken,
            expireTime: expireDate
        };

        // 为了适配旧模式
        // cf.auth.setToken(accessToken, expireDate);
        CookieHelper.setCookieValue(
            config.AccessTokenKey,
            accessToken,
            expireDate,
            cf.appPath
        );
        localStorage.setItem(config.AccessTokenKey, JSON.stringify(tokenJSON));
    }

    getAccessToken() {
        const strToken = localStorage.getItem(config.AccessTokenKey);
        if (!strToken) return null;
        const tokenJSON = JSON.parse(strToken);
        if (tokenJSON.expireTime <= Date.now()) return null;

        return tokenJSON.token;
    }

    removeAccessToken() {
        localStorage.removeItem(config.AccessTokenKey);
        CookieHelper.deleteCookie(config.AccessTokenKey, cf.appPath);
        cf.auth.setToken();
    }

    setEncryptedAccessToken(encryptedAccessToken, expireDate) {
        const tokenJSON = {
            token: encryptedAccessToken,
            expireTime: expireDate
        };
        localStorage.setItem(
            config.EncryptedAccessTokenKey,
            JSON.stringify(tokenJSON)
        );
        // 兼容cookie
        CookieHelper.setCookieValue(
            config.EncryptedAccessTokenKey,
            encryptedAccessToken,
            expireDate,
            cf.appPath
        );
    }

    getEncryptedAccessToken() {
        const strToken = localStorage.getItem(config.EncryptedAccessTokenKey);
        if (!strToken) return null;
        const tokenJSON = JSON.parse(strToken);
        if (tokenJSON.expireTime <= Date.now()) return null;

        return tokenJSON.token;
    }

    removeEncryptedAccessToken() {
        localStorage.removeItem(config.EncryptedAccessTokenKey);
        CookieHelper.deleteCookie(config.EncryptedAccessTokenKey, cf.appPath);
        cf.utils.setCookieValue(config.EncryptedAccessTokenKey, null);
    }
}

export default new TokenHelper();
